/*
 * Tracking Event Editor - Event Attendees Editor Dialog
 * Angular Module: trackerbase-app.views.tracking-event-editor.event-attendees-editor
 * Controller: eventAttendeesCtrl
 */
import angular from "angular";

import Assert from "tbAssert";

import TrackingTargetDataServiceModule from "../../services/TrackingTargetDataService";

import ngSanitize from "angular-sanitize";
import ngAnimate from "angular-animate";
import uiBootstrapModule from "angular-ui-bootstrap";
import kendoDirectives from "../../shims/kendoDirectives";

const mSanitizeSvc = new WeakMap();
const mModalInstance = new WeakMap();
const mTrackingTargetDataSvc = new WeakMap();

const mSelectedAttendees = new WeakMap();
const mAttendeeSelected = new WeakMap();
const mSelectedAttendeesListHasChanged = new WeakMap();

const mCurrentlyLoadingTargets = new WeakMap();
const mNoTargetResultsFound = new WeakMap();

const AttendeesDialogCancelledStatusMessage = "ATTENDEES_EDIT_USER_CANCEL";



class EventAttendeesEditorDialogController {
    constructor($sanitize, $uibModalInstance, TrackingTargetData, eventAttendees) {
        Assert.StrictAssert($sanitize != null, "Assertion Failure: Missing Ng-Sanitize Service Dependency");
        Assert.StrictAssert($uibModalInstance != null, "Assertion Failure: Missing UI Modal Instance Dependency");
        Assert.StrictAssert(TrackingTargetData != null, "Assertion Failure: Missing Tracking Target Data Service Dependency");
        Assert.StrictAssert(eventAttendees != null, "Assertion Failure: Missing Event Attendees Input Dependency");

        mSanitizeSvc.set(this, $sanitize);
        mModalInstance.set(this, $uibModalInstance);
        mTrackingTargetDataSvc.set(this, TrackingTargetData);
        mSelectedAttendees.set(this, eventAttendees);

        mSelectedAttendeesListHasChanged.set(this, false);

        mCurrentlyLoadingTargets.set(this, false);
        mNoTargetResultsFound.set(this, false);

        mAttendeeSelected.set(this, null);
    }
    
    get attendeeSelected() {
        return mAttendeeSelected.get(this);
    }

    set attendeeSelected(updatedVal) {
        mAttendeeSelected.set(this, updatedVal);
    }

    get selectedAttendees() {
        return mSelectedAttendees.get(this);
    }

    get loadingTargets() {
        return mCurrentlyLoadingTargets.get(this);
    }

    set loadingTargets(updatedVal) {
        mCurrentlyLoadingTargets.set(this, updatedVal);
    }

    get noTargetResults() {
        return mNoTargetResultsFound.get(this);
    }

    set noTargetResults(updatedVal) {
        mNoTargetResultsFound.set(this, updatedVal);
    }

    onAttendeesSelectorFiltering(e) {
        //Block filtering if there's nothing entered in the box.
        let filter = e.filter;

        if (!filter.value) {
            e.preventDefault();
        }
    }

    getTargets(searchTerm) {

        let sanitizedSearchTerm = mSanitizeSvc.get(this)(searchTerm) //sanitize any HTML
            .split("/").join("") // remove any "/" chars
            .substr(0,40); //limit to 40 chars.

        let searchResults = mTrackingTargetDataSvc.get(this).query({
            lastName: sanitizedSearchTerm
        });

        return searchResults.$promise
            .then(
                (res) => res.queryResults.map(
                    (ttResult) => {
                        return {
                            id: ttResult.trackingTargetId,
                            name: ttResult.firstName + " " + ttResult.lastName,
                            src: ttResult
                        };
                    }
                )
            );

    }

    addChosenTarget(e) {
        if (e != null) {
            e.preventDefault();
        }

        this.selectedAttendees.push(
            angular.copy(mAttendeeSelected.get(this).src)
        );

        mSelectedAttendeesListHasChanged.set(this, true);

        mAttendeeSelected.set(this, null);
    }

    removeTarget(idx) {
        this.selectedAttendees.splice(idx, 1);
        mSelectedAttendeesListHasChanged.set(this, true);
    }

    selectedAttendeesListHasChanged() {
        return mSelectedAttendeesListHasChanged.get(this);
    }

    ok() {
        let chosenAttendees = mSelectedAttendees.get(this);
        mModalInstance.get(this).close(chosenAttendees);
    }

    cancel() {
        mModalInstance.get(this).dismiss(AttendeesDialogCancelledStatusMessage);
    }
}

EventAttendeesEditorDialogController.$inject = [
    "$sanitize",
    "$uibModalInstance",
    "TrackingTargetData",
    "eventAttendees"
];

EventAttendeesEditorDialogController.dependencies = [
    ngAnimate,
    ngSanitize,
    uiBootstrapModule,
    kendoDirectives,
    TrackingTargetDataServiceModule
];

EventAttendeesEditorDialogController.template = require("./EventAttendeesEditorDialog.tpl.html");

EventAttendeesEditorDialogController.controllerAs = "eventAttendeesEditor";

EventAttendeesEditorDialogController.UserCancelledStatusMessage = AttendeesDialogCancelledStatusMessage;

export default EventAttendeesEditorDialogController;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-editor/EventAttendeesEditorDialogController.js
// module id = njpC
// module chunks = 1